import {
    GetBalenaDeviceQuerySchema,
    GetBalenaDeviceVariablesSchema,
    GetBalenaReleaseQuerySchema,
    GetBalenaReleaseVariablesSchema,
    type GetBalenaDeviceQuery
} from '../../views/DeviceConfig/balena_schemas'
import React, { useMemo } from 'react'
import { StatusAlertSmall } from '../../components/Wemolo'
import { useApi } from '../useApi'

export function getStatus(data: GetBalenaDeviceQuery | undefined): string | undefined {
    return String(data?.devices?.[0]?.is_online ?? 'No status available')
}

export const useBalenaDeviceData = (uuid: string | undefined) => {
    const sanitizedUuid = uuid?.replace('balena_', '')
    const variables = useMemo(
        () => (sanitizedUuid ? GetBalenaDeviceVariablesSchema.parse({ device_uuid: sanitizedUuid }) : undefined),
        [sanitizedUuid]
    )

    const result = useApi('/platform/get_balena_device', variables, GetBalenaDeviceQuerySchema, {
        queryKey: ['platform/get_balena_device', variables],
        enabled: !!variables
    })

    return {
        balenaDeviceData: result.data,
        refetchBalenaDeviceData: result.refetch,
        balenaStatus: getStatus(result.data),
        loading: result.isFetching
    }
}

export const useBalenaRelease = (releaseId: string | undefined | null) => {
    const variables = useMemo(
        () => (releaseId ? GetBalenaReleaseVariablesSchema.parse({ release_id: releaseId }) : undefined),
        [releaseId]
    )

    const result = useApi('/platform/get_balena_release', variables, GetBalenaReleaseQuerySchema, {
        queryKey: ['platform/get_balena_release', variables],
        enabled: !!releaseId
    })

    return {
        balenaReleaseData: result.data,
        refetchBalenaRelease: result.refetch,
        loading: result.isFetching
    }
}

export const getBalenaStatusIndicator = (deviceBalenaData: any | undefined) => {
    if (!deviceBalenaData) return <StatusAlertSmall variant="gray">NO DATA</StatusAlertSmall>

    let status = 'offline'
    if (
        deviceBalenaData.is_online === true &&
        deviceBalenaData.is_connected_to_vpn === true &&
        deviceBalenaData.api_heartbeat_state === 'online'
    ) {
        status = 'online'
    }
    if (deviceBalenaData.is_connected_to_vpn === false && deviceBalenaData.api_heartbeat_state === 'online') {
        status = 'heartbeat'
    }
    if (deviceBalenaData.api_heartbeat_state === 'offline' && deviceBalenaData.is_connected_to_vpn === true) {
        status = 'vpn'
    }

    let variant: 'green' | 'yellow' | 'red' | 'gray', text: string

    switch (status) {
        case 'online':
            variant = 'green'
            text = 'ONLINE'
            break
        case 'heartbeat':
            variant = 'yellow'
            text = 'Online (Heartbeat Only)'
            break
        case 'vpn':
            variant = 'yellow'
            text = 'Online (VPN Only)'
            break
        case 'offline':
            variant = 'red'
            text = 'OFFLINE'
            break
        default:
            variant = 'gray'
            text = status
    }
    return <StatusAlertSmall variant={variant}>{text}</StatusAlertSmall>
}
